import React from 'react';
import WithFlow from 'conversie-flow-bundle/assets/js/components/flow/WithFlow';
import { useForm } from 'react-hook-form';

/* Components */
import ConversionFlowForm from './ConversionFlowForm';
import ConversionFlowInPageForm from './ConversionFlowInPageForm';

/* Icons */
import CrossIcon from '~/../symbols/cross.svg';

/* Common */
import { Button, Modal } from '~/components/common';

/* Images */
import placeholder from '~/../img/vehicle-placeholder.png'

/* Utilities */
import { trans } from '~/utilities';
import BootstrapModal from "react-bootstrap/Modal";
import ConversionFlowSteps from "./ConversionFlowSteps";
import { getBanner } from "../helpers";

export default function ConversionFlowInPage({ flowUrl, flowDisclaimer, conversionUsps, klantenvertellenScore, suluImage, locationPhone, inPage = false, showDatalayer = false, datalayerData }) {
    const { ...form } = useForm({ shouldUnregister: true });

    return (
        <WithFlow
            flowUrl={flowUrl}
            flow={null}
            translate={trans}
        >
            {(passProps) => {
                const { flow, setStep } = passProps;
                const activeStep = flow?.steps?.find((step) => step.active);
                const handleClose = () => {
                    const firstStep = flow?.steps?.find((step) => step?.position === 1);
                    setStep(firstStep);
                    form.reset();
                }

                const Banner = getBanner(flow?.flowName);
                const image = flow?.summary?.vehicle?.image ? flow?.summary?.vehicle?.image : `${window.location.origin}${placeholder}`;
                const vehicleImage = suluImage ? window.location.host + image : image;

                return (
                    <>
                        <ConversionFlowInPageForm
                            {...passProps}
                            form={form}
                            handleClose={handleClose}
                            locationPhone={locationPhone}
                            flowDisclaimer={flowDisclaimer}
                            Banner={Banner}
                            inPage={inPage}
                            showDatalayer={showDatalayer}
                            datalayerData={datalayerData}
                        />
                        <Modal
                            open={activeStep?.position > 1 && !inPage}
                            handleClose={handleClose}
                            className={'flow__modal'}
                            modalTitle={flow?.flowTitle || trans(`app.modal.loading`)}
                            modalContent={
                                <>
                                    <BootstrapModal.Header>
                                        <div className="row gutters-2 justify-content-between align-items-center w-100">
                                            <div className="col-auto">
                                                <p className="text--18 font-weight-bold mb-0">{flow?.flowTitle || trans(`app.modal.loading`)}</p>
                                            </div>
                                            <div className="col-12 col-lg-auto order-1 order-lg-0">
                                                <ConversionFlowSteps
                                                    steps={flow?.steps}
                                                    setStep={setStep}
                                                />
                                            </div>
                                            <div className="col-auto">
                                                <Button
                                                    className="p-0"
                                                    theme="none"
                                                    showTitle={false}
                                                    title={'Sluiten'}
                                                    showIcon={true}
                                                    icon={CrossIcon}
                                                    iconSize={14}
                                                    iconClassName={'icon--lg-16'}
                                                    onClick={handleClose}
                                                />
                                            </div>
                                        </div>
                                    </BootstrapModal.Header>
                                    <BootstrapModal.Body>
                                        <>
                                            <ConversionFlowForm
                                                {...passProps}
                                                form={form}
                                                handleClose={handleClose}
                                                conversionUsps={conversionUsps}
                                                klantenvertellenScore={klantenvertellenScore}
                                                vehicleImage={vehicleImage}
                                                datalayerData={datalayerData}
                                            />
                                        </>
                                    </BootstrapModal.Body>
                                </>
                            }
                        />
                    </>
                )
            }}
        </WithFlow >
    )
}
